// Simple logger utility with enable/disable flag
const LOG_ENABLED = true; // Set to false to disable logs

export function setLogEnabled(val) {
  logger.LOG_ENABLED = val;
}

export const logger = {
  LOG_ENABLED,
    logStore: [],
    log: (...args) => {
      if (logger.LOG_ENABLED) {
        const line = args.map(arg =>
          typeof arg === 'object' ? JSON.stringify(arg) : String(arg)
        ).join(' : ');
        logger.logStore.push(line);
        console.log('[LOGGER]', line);
      }
    },
    printAll: () => {
      if (logger.LOG_ENABLED) {
        logger.logStore.forEach(line => {
          console.log('[LOGGER]', line);
        });
      }
    }
};
